import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.email) navigate("/admin/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-transparent border-b border-white/20 py-3 text-white font-body placeholder:text-white/30 focus:outline-none focus:border-gold transition-colors";

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-6" data-testid="admin-login">
      <div className="grain" />
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <div className="flex items-baseline justify-center gap-2 mb-4">
            <span className="font-display font-700 text-2xl text-white">TIMBO</span>
            <span className="font-editorial italic text-gold text-xl">da King</span>
          </div>
          <p className="overline text-gold">Media Portal</p>
        </div>
        <form
          onSubmit={submit}
          className="bg-white/[0.03] border border-white/10 backdrop-blur-xl p-8 md:p-10 space-y-8"
        >
          <input
            required
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={field}
            data-testid="login-email"
          />
          <input
            required
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={field}
            data-testid="login-password"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full font-display uppercase tracking-[0.2em] text-sm bg-gold text-black px-8 py-4 hover:bg-white transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <a href="/" className="block text-center mt-8 font-display uppercase tracking-[0.2em] text-xs text-white/40 hover:text-white transition-colors">
          ← Back to site
        </a>
      </div>
    </div>
  );
}
